export enum ContactMethod {
  DirectMessage,
  CreateReport,
  OtherMeans,
}
